/* ---------------------------------------------------
  Common
--------------------------------------------------- */

const agent = window.navigator.userAgent.toLowerCase();
const html = document.querySelector('html');
const body = document.querySelector('body');
const main = document.querySelector('main');
const header = document.querySelector('.js-header');
const headerLogo = document.querySelector('.js-header-logo');
const headerModal = document.querySelector('.js-header-modal');
const footer = document.querySelector('.js-footer');
const scrollContainer = document.querySelector('.js-scroll-container');



/**
 * DOM読み込み完了
 */
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(function() {
    body.classList.add('is-domloaded');
    html.classList.remove('is-scroll-prevent');
  }, 0);
});



/**
 * スマホ判定
 */
window.addEventListener('DOMContentLoaded', () => {
  if (agent.indexOf('iPhone') > 0 || agent.indexOf('iPad') > 0 || agent.indexOf('iPod') > 0 ) {
    html.classList.add('is-ios');
  } else if(agent.indexOf('ipad') > -1 || agent.indexOf('macintosh') > -1 && 'ontouchend' in document) {
    html.classList.add('is-ios');
  } else if (agent.indexOf('Android') > 0) {
    html.classList.add('is-android');
  }
});



/**
 * モーダル系
 */
const toggles = document.querySelectorAll('.js-toggle');
const toggleRemoves = document.querySelectorAll('.js-toggle-remove');
const humToggles = document.querySelectorAll('.js-hum');

// モーダル処理
let touchStartY;
// タッチしたとき開始位置を保存しておく
window.addEventListener('touchstart', function(event){
  touchStartY = event.changedTouches[0].screenY;
  //console.log('touchStartY : '+ touchStartY);
}, {passive: true});

let state = false;

let toggleOpen = () => {
  html.classList.add('is-scroll-prevent');
  body.classList.add('is-modal-open');
  main.setAttribute('inert','');
  headerPc.setAttribute('inert','');
  headerModal.removeAttribute('inert');
  footer.setAttribute('inert','');
  state = true;
}
let toggleClose = () => {
  main.removeAttribute('inert');
  headerPc.removeAttribute('inert');
  headerModal.setAttribute('inert','');
  footer.removeAttribute('inert');
  body.classList.remove('is-modal-open');
  html.classList.remove('is-scroll-prevent');
  state = false;
}

toggles.forEach(toggle => {
  toggle.addEventListener('click', () => {
    if (state == false){
      toggleOpen();
    } else {
      toggleClose();
    }
  });
}, {passive: true});

toggleRemoves.forEach(toggleRemove => {
  toggleRemove.addEventListener('click', () => {
    toggleClose();
    body.classList.remove('is-drawer');
  });
}, {passive: true});

// ハンバーガーメニュー
humToggles.forEach(humToggle => {
  humToggle.addEventListener('click', () => {
    if (!body.classList.contains('is-drawer')) {
      body.classList.add('is-drawer');
    } else {
      body.classList.remove('is-drawer');
    }
  });
}, {passive: true});



/**
 * TOPに戻る
 */
let scrTop = document.querySelector('.js-scr-top');
if(scrTop != null){
  window.addEventListener('scroll', function(){
    let scrollTop = html.scrollTop;
    if(scrollTop > 500){
      scrTop.classList.add('is-active');
    } else {
      scrTop.classList.remove('is-active');
    }
  });
}



/**
 * タブ切り替え
 */
window.addEventListener('DOMContentLoaded', () => {
  const tabList = document.querySelectorAll('.js-tab-item');
  for(let i = 0; i < tabList.length; i++) {
    tabList[i].addEventListener('click', clickTabSwitch);
  }

  // Listでタブ切り替え
  function clickTabSwitch(){
    const ancestorEl = this.closest('.js-tab');
    //console.log(ancestorEl);

    [].forEach.call(ancestorEl.querySelectorAll('.js-tab-item'), function(lists){
      lists.setAttribute('aria-selected','false');
    });
    [].forEach.call(ancestorEl.querySelectorAll('.js-tab-content'), function(content){
      content.setAttribute('hidden','');
    });

    const groupTabs = ancestorEl.querySelectorAll('.js-tab-item');
    //console.log(groupTabs);
    const arrayTabs = Array.prototype.slice.call(groupTabs);
    //console.log(arrayTabs);
    const index = arrayTabs.indexOf(this);
    //console.log(index);

    ancestorEl.querySelectorAll('.js-tab-content')[index].removeAttribute('hidden');
    ancestorEl.querySelectorAll('.js-tab-item')[index].setAttribute('aria-selected','true');
    ancestorEl.setAttribute('data-active-index',index);
    //console.log('data-active-index:'+index);
  }
});



/**
 * MVのyoutube
 */

if(document.querySelector('.js-bg-youtube') != null){
  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  let ytPlayer;

  function onYouTubeIframeAPIReady() {
    ytPlayer = new YT.Player('js-bg-youtube', {
      videoId: 'dH1bAtPBH04',
      playerVars: {
        playsinline: 1,
        autoplay: 1,
        fs: 0,
        rel: 0,
        controls: 0,
        disablekb: 1,
        enablejsapi: 1,
        modestbranding: 1,
        iv_load_policy: 3,
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    //video.classList.add('is-visited');
    //ytPlayer.mute();
    //ytPlayer.playVideo();
  });

  //ミュートにしてから再生する設定
  function onPlayerReady(event) {
    event.target.mute();
    event.target.playVideo();
  }

  //ループ設定
  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.ENDED) {
      event.target.mute();
      event.target.playVideo();
    }
  }
}



/**
 * 動画再生
 */

if(document.querySelectorAll('.js-video').length) {
  let videos = document.querySelectorAll('.js-video');

  videos.forEach((video) => {
    const videoFile = video.querySelector('.js-video-file');
    const videoBtn = video.querySelector('.js-video-btn');

    // 再生ボタン
    videoBtn.addEventListener('click', (e) => {
      videoFile.play();
      videoFile.setAttribute('controls','');
      videoBtn.classList.add('is-active');
    });
  });
}



/**
 * LocomotiveScroll
 */

// 慣性スクロール
const locoScroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: false,
  lerp: .05,
  multiplier: 2,
  firefoxMultiplier: 100,
  touchMultiplier: 2,
});
locoScroll.destroy();
locoScroll.init();

ScrollTrigger.refresh();
ScrollTrigger.scrollerProxy(scrollContainer, {
  scrollTop(value) {
    return arguments.length
      ? locoScroll.scrollTo(value, 0, 0)
      : locoScroll.scroll.instance.scroll.y;
  },
  getBoundingClientRect() {
    return {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },

  pinType: scrollContainer.style.transform
    ? "transform"
    : "fixed",
});



/**
 * ScrollTrigger
 */

gsap.registerPlugin(ScrollTrigger);
let mm = gsap.matchMedia();

ScrollTrigger.defaults({
  //markers: true,
});

// スムーズスクロール
//const anchorLinks = document.querySelectorAll('a[href^=\\#]:not([href$=\\#])');
const anchorLinks = document.querySelectorAll('a[href*=\\#]:not([href$=\\#]');
let headerHeight;
window.addEventListener('DOMContentLoaded', () => {
  headerHeight = header.clientHeight;
});
window.addEventListener('resize', function () {
  headerHeight = header.clientHeight;
});
anchorLinks.forEach((anchorLink) => {
  anchorLink.addEventListener('click', (e) => {
    let hashval = anchorLink.getAttribute('href');
    let domain = location.protocol + '//' + location.hostname;
    let pathname = location.pathname;
    hashval = hashval.replace(domain, '');
    if (hashval.includes(pathname)) {
      hashval = hashval.replace(pathname, '');
    }
    if(hashval.slice(0,1) != '#') {
      return;
    }
    let target = document.querySelector(hashval);
    e.preventDefault();
    e.stopPropagation();
    gsap.to(window, {duration: 1, scrollTo: {y: target, offsetY: headerHeight * 1.5}, ease: 'power2'});
    setTimeout(function(){
      ScrollTrigger.refresh();
    },100);
  });
});
window.addEventListener('DOMContentLoaded', () => {
  let hash = location.hash;
  if(!hash) {
    return;
  }
  let target = document.querySelector(hash);
  gsap.to(window, {duration: 1, scrollTo: {y: target, offsetY: headerHeight * 1.5}, ease: 'power2'});
  setTimeout(function(){
    ScrollTrigger.refresh();
  },100);
});

// is-active追加
let toggleClass = gsap.utils.toArray('.js-toggle-class');
toggleClass.forEach(el => {
  gsap.to(
    el,{
      scrollTrigger: {
        trigger: el,
        start: '5% 75%',
        end: '100% 100%',
        toggleClass: {targets: el, className: 'is-active'},
        once: true,
        //markers: true
      }
    },
  )
});

let toggleClassNarrow = gsap.utils.toArray('.js-toggle-class-narrow');
toggleClassNarrow.forEach(el => {
  gsap.to(
    el,{
      scrollTrigger: {
        trigger: el,
        start: '0% 100%',
        end: '100% 100%',
        toggleClass: {targets: el, className: 'is-active'},
        once: true,
        //markers: true
      }
    },
  )
});

// フェードイン
let fadein = gsap.utils.toArray('.js-fadein');
mm.add('(max-width: 1024px)', () => {
  fadein.forEach(el => {
    gsap.set(
      el,{
        opacity: 0,
        y: '2.5rem',
        ease: 'Power4.inOut',
      }
    )
    gsap.to(
      el,{
        opacity: 1,
        y: 0,
        duration: .7,
        scrollTrigger: {
          trigger: el,
          start: '5% 75%',
          end: '100% 100%',
          once: true,
          //markers: true
        }
      },
    )
  });
})
mm.add('(min-width: 1025px)', () => {
  fadein.forEach(el => {
    gsap.set(
      el,{
        opacity: 0,
        y: '5rem',
        ease: 'Power4.inOut',
      }
    )
    gsap.to(
      el,{
        opacity: 1,
        y: 0,
        duration: .7,
        scrollTrigger: {
          trigger: el,
          start: '5% 75%',
          end: '100% 100%',
          once: true,
          //markers: true
        }
      },
    )
  });
});

// パララックス
const parallax = document.querySelectorAll('.js-parallax');
for (let i = 0; i < parallax.length; i++) {
  let scrollSpeed = parallax[i].dataset.scrollSpeed;
  gsap.set(parallax[i], {
    y: scrollSpeed,
    ease: 'none',
  });
  gsap.to(parallax[i], {
    y: scrollSpeed * -1,
    scrollTrigger: {
      trigger: parallax[i],
      scrub: 1,
      start: '-400% 50%',
      end: '500% 50%',
      scroller: scrollContainer,
    }
  });
}

// 画像パララックス
const imgParallax = document.querySelectorAll('.js-img-parallax');
for (let i = 0; i < imgParallax.length; i++) {
  let scrollSpeed = imgParallax[i].dataset.scrollSpeed;
  gsap.set(imgParallax[i], {
    y: scrollSpeed,
    ease: 'none',
  });
  gsap.to(imgParallax[i], {
    y: scrollSpeed * -1,
    scrollTrigger: {
      trigger: imgParallax[i],
      scrub: 1.5,
      start: '-100% 50%',
      end: '200% 50%',
      scroller: scrollContainer,
    }
  });
}


window.addEventListener("loaded", function () {
  locoScroll.destroy();
  locoScroll.init();
  ScrollTrigger.refresh();
});
window.addEventListener('resize', function () {
  ScrollTrigger.refresh();
});



/**
 * スクロール時ヘッダーにスタイルをかける
 */
if(document.querySelector('.js-header-scroll-fire') != null){
  if (navigator.userAgent.toLowerCase().match(/webkit|msie 5/)) {
    documentElement = document.body;
  } else {
    documentElement = document.documentElement;
  }
  let prevY = window.scrollY;

  let headerScroll = (header) => {
    const currentY = window.scrollY;
    const headerScrollFire = document.querySelector('.js-header-scroll-fire');
    let fireLine = headerScrollFire.offsetHeight;

    if (currentY < prevY) {
      header.classList.remove('is-hidden');
    } else {
      if (currentY > 0) {
        header.classList.add('is-hidden');
      }
    }
    prevY = currentY;

    let scrollYHead = window.scrollY + headerHeight;
    if (scrollYHead > fireLine) {
      header.classList.add('is-scrolly');
    } else {
      header.classList.remove('is-scrolly');
    }
  }
  window.addEventListener('scroll', () => {
    headerScroll(header);
  });
  window.addEventListener('resize', () => {
    headerScroll(header);
  });
}




/**
 * INFORMATIONカテゴリーにis-activeを付ける
 */
window.addEventListener('DOMContentLoaded', () => {
  const cateNavItems = document.querySelectorAll('.js-cate-nav-item');
  const host = location.protocol + '://' + location.hostname;
  const pathname = location.pathname;
  function removeTrailingSlash(url) {
    return url.endsWith('/') ? url.substr(0, url.length - 1) : url
  }
  if(cateNavItems.length > 0) {
    for (let i = 0; i < cateNavItems.length; i++) {
      let url = cateNavItems[i].getAttribute('href').replace(host,"");
      if(removeTrailingSlash(pathname) == removeTrailingSlash(url)) {
        cateNavItems[i].classList.add('is-active');
      }
    }
  }
});
